import { render, staticRenderFns } from "./ArchivesEdit.vue?vue&type=template&id=41d309eb&scoped=true"
import script from "./ArchivesEdit.vue?vue&type=script&lang=js"
export * from "./ArchivesEdit.vue?vue&type=script&lang=js"
import style0 from "./ArchivesEdit.vue?vue&type=style&index=0&id=41d309eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d309eb",
  null
  
)

export default component.exports